<template>
    <div :style="$lang == 2 ? {direction:'ltr'} : {direction:'rtl'}">
        <Card>
            <p slot="title">{{$t('menu_name.customer_title')}}</p>

            <Row :gutter="20">
                <Col :span="8">
                    <Input search enter-button :placeholder="$t('search.search_placeholder')" @on-search="search" size="large"/>
                </Col>
                <Row :span="2">
                    <el-button icon="el-icon-plus" @click="create">{{$t('create_submit')}}</el-button>
                </Row>
                <Col :span="2">
                    <download-excel :header="$t('customer_table.xls_table_header')" class="export-excel-wrapper" :data="tableData" :fields="$lang == 2 ? jsonFile : jsonFileUy" name="客户管理.xls">
                        <el-button icon="el-icon-download">{{$t('export_submit')}}</el-button>
                    </download-excel>

                </Col>
            </Row>

            <div style="padding: 10px">

                <el-table
                        :data="tableData.slice((currentPage-1)*pagesize,currentPage*pagesize)"
                        :header-cell-style="{'text-align':'center'}"
                        :cell-style="{'text-align':'center'}"
                        max-height="750"
                        style="width: 100%"
                        v-loading="tableLoading">
                    <el-table-column
                            prop="id"
                            type="index"
                            label="ID">
                    </el-table-column>
                    <el-table-column
                            prop="name_ug"
                            :label="$t('customer_table.name_ug')">
                    </el-table-column>
                    <el-table-column
                            prop="name_zh"
                            :label="$t('customer_table.name_zh')">
                    </el-table-column>
                    <el-table-column
                            prop="contact"
                            :label="$t('customer_table.contact')">
                    </el-table-column>
                    <el-table-column
                            prop="phone"
                            :label="$t('customer_table.phone')">
                    </el-table-column>
                    <el-table-column
                            prop="state"
                            :label="$t('customer_table.state')">
                        <template slot-scope="scope">
                            <div v-if="scope.row.state == $t('state_ok')">
                                <el-tag>{{scope.row.state}}</el-tag>
                            </div>
                            <div v-else>
                                <el-tag type="danger">{{scope.row.state}}</el-tag>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="created_at"
                            :label="$t('customer_table.created_at')">
                    </el-table-column>
                    <el-table-column
                            :label="$t('customer_table.operation')"
                            width="250">
                        <template slot-scope="scope">
                            <Row style="text-align: center;justify-items: center;margin: 0 auto">
                                <Col :span="11">
                                    <el-button icon="el-icon-edit" @click="handleEdit(scope.row)" type="primary" size="small">
                                        {{$t("customer_table.edit_submit")}}
                                    </el-button>
                                </Col>
                                <Col :span="11">
                                    <el-button icon="el-icon-delete" @click="handleDelete(scope.row)" type="danger" size="small">
                                        {{$t("customer_table.delete_submit")}}
                                    </el-button>
                                </Col>
                            </Row>

                        </template>
                    </el-table-column>
                </el-table>

                <div style="text-align: center;margin-top: 30px;">
                    <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="total"
                            @current-change="current_change">
                    </el-pagination>
                </div>

            </div>
        </Card>

        <div style="direction: ltr">
            <el-dialog
                    :title="type == 1 ? $t('system_create') : $t('system_edit')"
                    :visible.sync="dialogVisible"
                    width="70%"
                    :close-on-click-modal="false"
                    :before-close="handleClose">
                <Form ref="customerRef" :model="customerForm" :rules="customerRules" :style="$lang == 2 ? {direction:'ltr'} : {direction:'rtl'}">
                    <Row :gutter="20">
                        <Col :span="12">
                            <FormItem>
                                <upload-image :file-list="logo_avatars" action="customer/cms_up_image" :limit="1" :multiple="false" list-type="picture" @images="avatar">
                                    <div slot="isautoload">
                                        <el-button type="danger">{{$t('customer_table.avatar_upload')}}</el-button>
                                    </div>
                                </upload-image>
                            </FormItem>
                        </Col>
                        <Col :span="12">
                            <FormItem prop="shop_name">
                                <Input v-model="customerForm.shop_name" @on-enter="customerCreate('customerRef')" type="text" :placeholder="$t('customer_table.create_shop_name')" size="large"></Input>
                            </FormItem>
                        </Col>
                        <Col :span="12">
                            <FormItem prop="contact">
                                <Input v-model="customerForm.contact" @on-enter="customerCreate('customerRef')" type="text" :placeholder="$t('customer_table.create_contact')" size="large"></Input>
                            </FormItem>
                        </Col>
                        <Col :span="12">
                            <FormItem prop="phone">
                                <Input v-model="customerForm.phone" @on-enter="customerCreate('customerRef')" type="text" :placeholder="$t('customer_table.create_phone')" size="large"></Input>
                            </FormItem>
                        </Col>
                        <Col :span="12">
                            <FormItem prop="categoey_id">
                                <el-select v-model="customerForm.category_id" :placeholder="$t('select')" style="width: 100%" :no-data-text="$t('empty')">
                                    <el-option
                                            v-for="item in categorys"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </FormItem>
                        </Col>
                        <Col :span="12">
                            <FormItem prop="address">
                                <Input v-model="customerForm.address" @on-enter="customerCreate('customerRef')" type="text" :placeholder="$t('customer_table.create_address')" size="large"></Input>
                            </FormItem>
                        </Col>
                    </Row>


                    <FormItem prop="image">
                        <upload-image :file-list="shop_image" delete-remove="deleteRemove" :type="true" :limit="$limit" action="customer/cms_up_image" @images="images"></upload-image>
                    </FormItem>

                    <FormItem prop="state">
                        <el-radio-group v-model="customerForm.state" size="medium">
                            <el-radio :label="1" border>{{$t('state_ok')}}</el-radio>
                            <el-radio :label="0" border>{{$t('state_fail')}}</el-radio>
                        </el-radio-group>
                    </FormItem>

                </Form>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="handleClose">{{$t('cancel_button')}}</el-button>
                    <el-button type="primary" @click="customerCreate('customerRef')">{{$t('confrim_button')}}</el-button>
                </div>

            </el-dialog>
        </div>


    </div>
</template>

<script>
    import UploadImage from "@/components/UploadImage";
    import UploadImageEdit from "@/components/UploadImageEdit";
    export default {
        name: "Customer",
        data(){
            return{
                tableLoading:true,

                tableData: [],

                dialogVisible:false,

                categorys:[],

                logo_avatars:[],
                shop_image:[],

                customer_id:0,


                total:0,
                pagesize:10,
                currentPage:1,



                //type  判断时新增还是编辑
                type:0,
                customerForm:{
                    shop_name:'',
                    // name_zh:'',
                    contact:'',
                    phone:'',
                    state:1,
                    category_id:'',
                    images:[],
                    terminal_id:7,
                    address:'',
                    logo:''
                },
                customerRules:{
                    shop_name:[
                        {required:true,message:this.$i18n.t("customer_table.create_shop_name"),trigger:'blur'}
                    ],
                    // name_ug:[
                    //     {required:true,message:this.$i18n.t("customer_table.create_name_ug"),trigger:'blur'}
                    // ],
                    contact:[
                        {required:true,message:this.$i18n.t("customer_table.create_contact"),trigger:'blur'}
                    ],
                    phone:[
                        {required:true,message:this.$i18n.t("customer_table.create_phone"),trigger:'blur'}
                    ],
                    state: [
                        {required:true,message:this.$i18n.t("customer_table.create_state")}
                    ],
                    address: [
                        {required:true,message:this.$i18n.t("customer_table.create_address"),trigger:'blur'}
                    ],
                },

                jsonFile:{
                    ID:'id',
                    维语昵称:'name_ug',
                    汉语昵称:'name_zh',
                    联系人:'contact',
                    手机号:'phone',
                    状态:'state',
                    创建时间:'created_at',
                },
                jsonFileUy:{
                    ID:'id',
                    'ئۇيغۇرچە ئىسمى':'name_ug',
                    'خەنزۇچە ئىسمى':'name_zh',
                    'ئالاقىلاشقۇچى':'contact',
                    'تىلفۇن نۇمۇر':'phone',
                    'ھالىتى':'state',
                    'قېتىلغان ۋاقتى':'created_at',
                }


            }
        },
        components:{UploadImage},
        mounted() {
            this.show();
        },
        methods:{
            search(e){
                //第一次请求获取列表
                this.$http.get('customer/listCms',{
                    params:{
                        keyword:e,
                        limit:10
                    }
                }).then((res)=>{
                    this.tableData = res.data
                    this.total = res.count
                })
            },
            show(){
                this.$http.get('customer/listCms',{
                    params:{
                        keyword:'',
                        limit:10
                    }
                }).then((res)=>{
                    this.tableData = res.data
                    this.total = res.count
                })
            },
            create(){
                this.type = 1; // 新增标识
                this.dialogVisible = true;
                this.$http.get('customer/cateList')
                    .then((res)=>{
                        this.categorys = res.data.items
                    })
            },
            handleClose(){
                this.$refs.customerRef.resetFields();
                this.dialogVisible = false;
                this.customerForm.shop_name = '';
                // this.customerForm.name_zh = '';
                this.customerForm.contact = '';
                this.customerForm.phone = '';
                this.customerForm.category_id = '';
                this.customerForm.images = [];
                this.customerForm.address = '';
                this.customerForm.logo = '';

                this.logo_avatars = [];
                this.shop_image   = [];




            },
            current_change(page){
                this.currentPage = page;
            },
            handleEdit(row){
                this.type = 2
                var editDate = row
                this.$http.get('customer/cateList')
                    .then((res)=>{
                        this.categorys = res.data.items
                    })
                this.customerForm = {
                    shop_name:editDate.name_ug,
                    contact:editDate.contact,
                    phone:editDate.phone,
                    category_id:editDate.category_id,
                    images:[],
                    terminal_id:7,
                    state:editDate.states,
                    address:editDate.address,
                    logo:editDate.logo
                }
                this.customer_id = editDate.id
                this.logo_avatars = [
                    {name:'avatar.png',url:this.$appUrl + editDate.logo}
                ]
                var images = editDate.images

                var that = this
                images.forEach((item,index)=>{
                    that.shop_image.push({
                        name:item.name,
                        url:that.$appUrl + item.url
                    })
                })
                images.forEach((item,index)=>{
                    this.customerForm.images.push(item.url)
                })

                this.dialogVisible = true
            },
            handleDelete(row){
                var id  = row.id
                this.$msConMessage.confirm(this.$i18n.t('system_delete'),this.$i18n.t('system'),{
                    confirmButtonText:this.$i18n.t('confrim_button'),
                    cancelButtonText:this.$i18n.t('cancel_button'),
                    type:'warning',
                    closeOnClickModal:false
                }).then((res)=>{
                    this.$http.post('customer/delete',{
                        id:id
                    }).then((res)=>{
                        this.show()
                    })
                }).catch(()=>{
                    return true;
                })
            },
            customerCreate(formLogin){
                // console.log(this.$emit('uploads'))
                var customerForm = this.customerForm;
                this.$refs[formLogin].validate((valid)=>{
                    if (valid){
                        if (customerForm.category_id.length == 0){
                            this.$msMessage.error(this.$i18n.t('customer_table.empty_category'))
                        }else if(customerForm.images.length <= 0){
                            this.$msMessage.error(this.$i18n.t('customer_table.empty_images'));
                        }else if (customerForm.logo == '') {
                            this.$msMessage.error(this.$i18n.t('customer_table.empty_avatar_upload'));
                        }else{
                            if (this.type == 1){
                                this.$http.post('customer/create',{
                                    shop_name:customerForm.shop_name,
                                    contact:customerForm.contact,
                                    phone:customerForm.phone,
                                    category_id:customerForm.category_id,
                                    images:customerForm.images,
                                    terminal_id:customerForm.terminal_id,
                                    state:customerForm.state,
                                    address:customerForm.address,
                                    logo:customerForm.logo
                                }).then((res)=>{
                                    this.handleClose()
                                    this.dialogVisible = false;
                                    this.show()
                                })

                            }else{

                                this.$http.post('customer/update',{
                                    id:this.customer_id,
                                    shop_name:customerForm.shop_name,
                                    contact:customerForm.contact,
                                    phone:customerForm.phone,
                                    category_id:customerForm.category_id,
                                    images:customerForm.images,
                                    terminal_id:7,
                                    state:customerForm.state,
                                    address:customerForm.address,
                                    logo:customerForm.logo
                                }).then((res)=>{
                                    this.handleClose()
                                    this.dialogVisible = false;
                                    this.show()
                                })

                            }

                        }
                    }else{
                        return false;
                    }
                })
            },
            images(res){
                console.log(res)

                var images = res;

                this.customerForm.images.push(images.image_url)

            },
            avatar(res){
                this.customerForm.logo = res.image_url
            }
        },
    }
</script>

<style scoped>
    /deep/.el-dialog{
        border-radius: 10px;
    }
    /deep/ .el-upload--picture-card .upload_avatar{
        border-radius: 120px;
    }
</style>